var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-personalize-preview-panel-section"},[(_vm.title)?_c('p',{staticClass:"login-personalize-preview-panel-section-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }